import React, { useMemo } from 'react';
import { MenuFiltersProps, StatusOption } from './types';
import { FilterBody } from './menu-filter.styles';
import { Filter } from '@shared/ui/filter/filter';
import { Select } from '@shared/ui/select/select';
import { ORDER_STATUSES } from './constants';

export const MenuFilters: React.FC<MenuFiltersProps> = ({ parameters, setParameters }) => {
    const selectedStatuses = useMemo(() => {
        return ORDER_STATUSES.filter((option) => parameters?.statuses?.includes(option.value));
    }, [parameters]);

    const handleChangeStatus = (value: StatusOption[]) => {
        if (!setParameters || !parameters) {
            return;
        }
        const selectedStatuses = value.map((option) => option.value);
        setParameters({ ...parameters, statuses: selectedStatuses });
    };

    const handleResetFilters = () => {
        if (!setParameters || !parameters) {
            return;
        }
        setParameters({ ...parameters, statuses: undefined });
    };

    return (
        <Filter onResetAllFilters={handleResetFilters}>
            <FilterBody>
                <Select
                    multiselect
                    label='Статус'
                    placeholder='Выберите статус'
                    options={ORDER_STATUSES}
                    values={selectedStatuses}
                    onChange={handleChangeStatus}
                />
            </FilterBody>
        </Filter>
    );
};
